import React from 'react';
import PropTypes from 'prop-types';

import {dispatch, connect} from 'utils/state_manager';

import {Stack} from 'views/components';
import {useQuery} from 'views/module';

import backend from 'utils/backend';

import HeaderSection from './sections/HeaderSection';
import FormSection from './sections/form/FormSection';
import LoadingSkeleton from './components/LoadingSkeleton';

const EventFeedbackInput = (props) => {
  const {
    eventFeedbackRn,
    statusProgressWrap: progressWrap,
    setIsFeedbackSent,
  } = props;

  const queryParamsObj = useQuery();

  const [eventFeedbackData, setEventFeedbackData] = React.useState(null);
  const [isSubmitLoading, setIsSubmitLoading] = React.useState(false);

  const handleSendFeedback = async (feedbackData) => {
    progressWrap(async () => {
      setIsSubmitLoading(true);
      try {
        const body = {feedback: feedbackData};
        await backend.clientSupport.sendEventFeedback(eventFeedbackRn, body);
        setIsFeedbackSent(true);
      } finally {
        setIsSubmitLoading(false);
      }
    });
  };

  React.useEffect(() => {
    progressWrap(async () => {
      setEventFeedbackData(true);
      const result = await backend.clientSupport.getEventFeedback(eventFeedbackRn);
      setEventFeedbackData(result);
    });
  }, [eventFeedbackRn]);

  if (!eventFeedbackData) {
    return (
      <LoadingSkeleton/>
    );
  }

  return (
    <Stack>
      <HeaderSection/>
      <FormSection
        isSubmitLoading={isSubmitLoading}
        handleSendFeedback={handleSendFeedback}
        caregiverHappinessQueryParam={queryParamsObj?.['caregiver-happiness']}
      />
    </Stack>
  );
};

EventFeedbackInput.propTypes = {
  eventFeedbackRn: PropTypes.string.isRequired,
  statusProgressWrap: PropTypes.func.isRequired,
  setIsFeedbackSent: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({});

export default connect(mapStateToProps, dispatch)(React.memo(EventFeedbackInput));
